export const roundNumericValue = (value: any): number | undefined => {
  return typeof value === 'number' ? Math.round(value) : undefined;
};
